<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path :fill="!invert ? '#fff' : ''" d="M10 9h4v10h-4z"></path>
    <path :fill="invert ? '#fff' : ''" d="M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"></path>
  </svg>
</template>

<script>
export default {
  name: 'AlertIcon',
  props: {
    /** 地の色を反転させます */
    invert: Boolean,
  },
}
</script>
